export default __webpack_public_path__ + "static/media/calendar.52f58154.svg";